import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function Stock() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showData, setShowData] = useState(false);

  const fetchData = async () => {
    if (!fromDate || !toDate) {
      alert("Please select both 'From' and 'To' dates.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://U1.hunzagroupofindustries.com.pk/api/Production?fDate=${fromDate}&tDate=${toDate}&CompId=1`
      );
      if (!response.ok) throw new Error("Failed to fetch data");
      const result = await response.json();
      setData(result);
      setShowData(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined) {
      return "0"; // or return 0 if you prefer a numeric value
    }
    return Intl.NumberFormat().format(num);
  };
  

  return (
    <div>
      <h3 className="text-center mb-4">Stock In Process </h3>

      {/* Date Selection Input */}
      <div className="row mb-4">
        <div className="col-md-4 offset-md-2">
          <label htmlFor="fromDate" className="form-label">
            From Date:
          </label>
          <input
            type="date"
            id="fromDate"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="col-md-4">
          <label htmlFor="toDate" className="form-label">
            To Date:
          </label>
          <input
            type="date"
            id="toDate"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <div className="col-md-4 offset-md-4">
          <button
            className="btn btn-primary w-100 mt-3"
            onClick={fetchData}
            disabled={loading}
          >
            {loading ? "Loading..." : "Show Data"}
          </button>
        </div>
      </div>
      <div className="row">
        
      </div>

      {/* Error State */}
      {error && (
        <div className="alert alert-danger mt-4 text-center">
          {error}
        </div>
      )}

      {/* Data Table */}
      {showData && !loading && data.length > 0 && (
        <div className="table-responsive mt-4">
          <table className="table table-bordered table-hover table-sm">
            <thead className="table-dark">
              <tr>
                <th>Date</th>
                <th className="text-end">Crushing On Date</th>
                <th className="text-end">Crushing To Date</th>
                <th className="text-end">Rec. On Date</th>
                <th className="text-end">Rec. To Date</th>
              
              
                <th className="text-end">On Date Production</th>
                <th className="text-end">To Date Production</th>
                <th className="text-end">Stock in Process</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                 <td>{new Date(item.Date).toLocaleDateString('en-GB')}</td>  {/* Display as DD/MM/YYYY */}

                  <td className="text-end">{formatNumber(item.CrushingOnDate ||=0)}</td>
                  <td className="text-end">{formatNumber(item.CrushingToDate ||=0)}</td>

                  <td className="text-end">{formatNumber(item.RecOnDate ||=0)}</td>
                  <td className="text-end">{formatNumber(item.RecToDate ||=0)}</td>
               
                  
                 
                  <td className="text-end">{formatNumber(item.OnDateProduction ||=0)}</td>
                  <td className="text-end">{formatNumber(item.ToDateProduction ||=0)}</td>

                  <td className="text-end">{formatNumber((item.StockinProcess||=0).toFixed(2))}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* No Data Available */}
      {showData && !loading && data.length === 0 && (
        <div className="alert alert-warning text-center mt-4">
          No data available for the selected date range.
        </div>
      )}
    </div>
  );
}

export default Stock;
